export enum PaymentTypeEnum {
    DD = 'DD',
    BT = 'BT'
}